import api from '@/api'

const SESSION_STORAGE_KEY = 'client_stocks'

const SET_STOCKS = 'SET_STOCKS'
const ADD_STOCK = 'ADD_STOCK'

const SET_STOCK = 'SET_STOCK'
const UNSET_STOCK = 'UNSET_STOCK'

const restoreStocksFromSessionStorage = () => {
  const storedData = sessionStorage.getItem(SESSION_STORAGE_KEY)
  if (storedData) {
    return JSON.parse(storedData)
  }
  return []
}

export default {
  namespaced: true,

  state () {
    return {
      stocks: restoreStocksFromSessionStorage(),
      currentStock: null
    }
  },

  getters: {
    stocks: (state) => state.stocks,
    currentStock: (state) => state.currentStock
  },

  mutations: {
    [SET_STOCKS] (state, data) {
      state.stocks = data
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data))
    },

    [ADD_STOCK] (state, data) {
      state.stocks.push(data)
    },

    [SET_STOCK] (state, data) {
      state.currentStock = data
    },

    [UNSET_STOCK] (state) {
      state.currentStock = null
    }
  },

  actions: {
    async loadStocks ({ commit }, params = {}) {
      const { data } = await api.stocks.list(params)
      commit(SET_STOCKS, data || [])
    },

    async createStock ({ commit }, payload) {
      const { data, error } = await api.stocks.create(payload)
      commit(ADD_STOCK, data)
      return { error }
    },

    setStock ({ commit }, stock) {
      commit(SET_STOCK, stock)
    },

    async updateStock ({ dispatch }, item) {
      const resp = await api.stocks.updateById(item.id, item)
      dispatch('loadStocks')
      return resp
    },

    async deleteStock ({ dispatch }, item) {
      await api.stocks.deleteById(item.id)
      dispatch('loadStocks')
    }
  }
}
